import { Component, OnInit } from '@angular/core';
import { CrudService } from '../crud.service'; 
@Component({
  selector: 'app-tips-for-bsc-computer-science-student',
  templateUrl: './tips-for-bsc-computer-science-student.component.html',
  styleUrls: ['./tips-for-bsc-computer-science-student.component.scss']
})
export class TipsForBscComputerScienceStudentComponent implements OnInit {

  constructor(private crudService: CrudService) { }
  baseUrl = this.crudService.baseUrl;

  ngOnInit(): void {
  }

}
